import ActivationAccountForm from "./activation-account-form";

export  default ActivationAccountForm;